import styled from 'styled-components'

export default styled.div`
    svg {
        margin-right: 0;
        width: 26px;
    }

    .CircularProgressbar-text {
        fill: #000000;
        font-size: 30px;
    }

    .CircularProgressbar-path {
        stroke: ${(props) => props.theme.palette.gray[800]};
    }
`
